import { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import AppSettings from "../../configs/appSettings";
import "./style.css";
import {Image, ImageType} from "../../models/image";

const ImageCard = ({ imageUrl, name, sku }: { imageUrl: string, name: string, sku: string }) => {
  let link =`/model/${sku}`;

  return (
    <div className="image-page-cards">
      <Card className="image-cards">
        <a href={link} target="_blank" className="watermark">
          <img className="card-img prd-card-img" title={name} src={imageUrl}></img>
        </a>
      </Card>
      <div style={{marginBottom:'10px', marginTop:'10px', textAlign: 'center'}}>
        <a href={link} target="_blank" style={{color: '#212529'}} >
          {name}
        </a>
      </div>
    </div>
  );
};

export default ImageCard;
